import z from "zod"
import {
  ConversationCapabilityExecutionResponseDataSchema,
  MessageResponseDataSchema,
} from "../conversations/response_data"
import { KnowledgeBaseItemKind } from "../knowledgeBase/response_data"

export const MessagesPageResponseDataSchema = z.object({
  messages: z.array(MessageResponseDataSchema),
  pageInfo: z.object({
    hasMore: z.boolean(),
    oldestId: z.bigint().transform(String).nullable(),
    newestId: z.bigint().transform(String).nullable(),
  }),
})

export const MessageKnowledgeBaseItemSchemaResponseData = z.object({
  source: z.literal("KnowledgeBase"),
  messageId: z.bigint().transform(String),
  changeLogId: z.bigint().transform(String).nullable(),
  knowledgeBaseItemId: z.bigint().transform(String),
  score: z.number(),
  knowledgeBaseItem: z
    .object({
      campaignId: z.bigint().transform(String).nullish(),
      kind: z.enum(KnowledgeBaseItemKind).optional(),
    })
    .nullish(),
})
export const MessageKnowledgeBaseItemsResponseData = z.array(
  MessageKnowledgeBaseItemSchemaResponseData,
)

export const MessageCapabilityExecutionsResponseDataSchema = z.array(
  ConversationCapabilityExecutionResponseDataSchema,
)
